import { useEffect } from 'react';

export const useDocumentTitle = (title: string, suffix = '') => {
    useEffect(() => {
        const prevTitle = document.title;
        document.title = `${title} ${suffix}`;

        return () => {
            document.title = prevTitle;
        };
    }, [title, suffix]);
};